import React from "react";
import "./BidAskBars.css";

const data = [
  { label: "VAB", left: 9, right: 6 },
  { label: "QUM", left: 8, right: 11 },
  { label: "BHR", left: 10, right: 5 },
  { label: "LDG", left: 5, right: 15 },
  { label: "FOD", left: 13, right: 18 },
  { label: "XUG", left: 4, right: 11 },
  { label: "YXS", left: 10, right: 4 },
  { label: "OEX", left: 19, right: 15 },
  { label: "HEA", left: 6, right: 5 },
  { label: "SNF", left: 7, right: 2 },
  { label: "WXA", left: 11, right: 16 },
  { label: "XMW", left: 2, right: 5 },
  { label: "TNE", left: 12, right: 14 },
  { label: "TQG", left: 16, right: 7 },
  { label: "BBQ", left: 8, right: 3 },
  { label: "XFN", left: 13, right: 18 },
  { label: "ETW", left: 16, right: 11 },
  { label: "MFU", left: 3, right: 18 },
  { label: "GHQ", left: 6, right: 4 },
  { label: "IEW", left: 8, right: 17 },
];

const maxValue = Math.max(
  ...data.flatMap((d) => [d.left, d.right])
);

export default function BidAskBars() {
  return (
    <div className="bidask-container">
      {data.map((item, index) => (
        <div className="row" key={index}>
          {/* LEFT BAR */}
          <div className="bar-section left">
            <div
              className="bar left-bar"
              style={{ width: `${(item.left / maxValue) * 100}%` }}
            >
              {item.left}
            </div>
          </div>

          {/* CENTER LABEL */}
          <div className="center-label">{item.label}</div>

          {/* RIGHT BAR */}
          <div className="bar-section right">
            <div
              className="bar right-bar"
              style={{ width: `${(item.right / maxValue) * 100}%` }}
            >
              {item.right}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
